import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user";
import newsFeedsComment from "./modules/newsFeedsComment";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ],
  modules: {
    user,
    newsFeedsComment
  }
});
